import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Tag } from 'primereact/tag'
import { mockContracts, mockClients } from '../../../mocks'
import { Contract } from '../../../types/entities'
import { contractStatusLabel, contractStatusSeverity } from '../utils/contractHelpers'

const ContractsListPage: React.FC = () => {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')

  const filtered = mockContracts.filter((c) =>
    c.title.toLowerCase().includes(search.toLowerCase())
  )

  const clientTemplate = (contract: Contract) => {
    const client = mockClients.find((c) => c.id === contract.clientId)
    return client?.name ?? '–'
  }

  const statusTemplate = (contract: Contract) => (
    <Tag value={contractStatusLabel(contract.status)} severity={contractStatusSeverity(contract.status)} />
  )

  const feeTemplate = (contract: Contract) =>
    `R$ ${contract.monthlyFee.toLocaleString('pt-BR')}/mês`

  const dateTemplate = (contract: Contract) =>
    `${new Date(contract.startDate).toLocaleDateString('pt-BR')} – ${new Date(contract.endDate).toLocaleDateString('pt-BR')}`

  const actionsTemplate = (contract: Contract) => (
    <Button
      icon='pi pi-eye'
      text
      severity='secondary'
      tooltip='Ver detalhes'
      onClick={() => navigate(`/dashboard/contratos/${contract.id}`)}
    />
  )

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>Contratos</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--text-color-secondary)' }}>
            {mockContracts.length} contratos cadastrados
          </p>
        </div>
        <span className='p-input-icon-left'>
          <i className='pi pi-search' />
          <InputText
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder='Buscar contrato...'
          />
        </span>
      </div>

      <DataTable
        value={filtered}
        paginator
        rows={10}
        emptyMessage='Nenhum contrato encontrado.'
        rowHover
        onRowClick={(e) => navigate(`/dashboard/contratos/${(e.data as Contract).id}`)}
        style={{ cursor: 'pointer' }}
      >
        <Column field='title' header='Título' sortable />
        <Column header='Cliente' body={clientTemplate} sortable sortField='clientId' />
        <Column header='Vigência' body={dateTemplate} />
        <Column header='Mensalidade' body={feeTemplate} sortable sortField='monthlyFee' />
        <Column header='Status' body={statusTemplate} sortable sortField='status' />
        <Column header='' body={actionsTemplate} style={{ width: '60px', textAlign: 'center' }} />
      </DataTable>
    </div>
  )
}

export default ContractsListPage
